// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"443":"about","768":"page"}[chunkId] || chunkId) + "." + {"216":"a6d8ea31","280":"47401495","390":"c1dd9a8e","443":"f2e3a4f7","479":"37d88beb","551":"8f36f2ff","742":"6aab02ac","768":"d7e22264","791":"72f934f5","955":"3538f164"}[chunkId] + ".css";
};